export const borderRadius = '2px';
